export const ROOT = '/dors';
export const MODULE = 'DORS';
